export default "__VITE_ASSET__BiS03Ugk__"